import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <footer id="footer">
      <div className="footer-monogram">L &amp; M</div>
      <div className="footer-rule"></div>
      <p className="footer-names">Lucero &amp; Miguel</p>
      <p className="footer-date">19 · Septiembre · 2026</p>
      <p className="footer-credit">
        Diseñado con ♥ por{" "}
        <a href="https://keweee.com" target="_blank" rel="noreferrer" className="footer-link">
          keweee
        </a>
      </p>
    </footer>
  );
};

export default Footer;
